import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SettlementsService {

  constructor(private readonly http: HttpClient) { }

  getUpcomingSettlements(payload: any) {
    let url = environment.BASE_URL + '/v1/settlement/upcoming';
    return this.http.get(url, { params: payload })
  }

  getSettlementsHistory(payload: any) {
    let url = environment.BASE_URL + '/v1/settlement/history';
    return this.http.get(url, { params: payload })
  }

  createSettlement(payload: any) {
    let url = environment.BASE_URL + '/v1/settlement/manual';
    return this.http.post(url, payload)
  }

  getHistoryCount(params: any) {
    let url = environment.BASE_URL + '/v1/settlement/count';
    return this.http.get(url, { params: params })
  }

  getSummaryCards(params: any) {
    let url = environment.BASE_URL + '/v1/settlement/summary-cards';
    return this.http.get(url, { params: params })
  }

}
